<form [formGroup]="juridicoForm" (ngSubmit)="validateForm()">
  <div class="myForm">
    @if (currentStep === 1) {
      <!-- Sección 1: Información general / Datos generales -->
      <div class="form-section-header mb-2">
        <h3 class="form-section-header__title">Información general</h3>
        <p class="form-section-header__subtitle mt-3">
          <img src="assets/img/Inicio_sesion/svg/Ico_Datos_Generales.svg"
            alt="" class="form-section-header__icon" aria-hidden="true" />
          Datos generales
        </p>
      </div>
      <div class="form-fields-flow mt-3">
        <div class="form-field-item">
          <div class="mb-3 required" [ngClass]="{ err: validateField('razonSocial') }">
            <label for="razonSocial" class="form-label">Razón social</label>
            <input
              type="text"
              maxlength="100"
              class="form-control"
              formControlName="razonSocial"
              id="razonSocial"
              placeholder="Digita Razón social"
              #inputRazon
              (input)="inputRazon.value = $event.target.value.toUpperCase()"
              appNextFieldId="numeroDocumento"
              [ngClass]="{ 'is-invalid': validateField('razonSocial') }"
              required
            />
            <div class="invalid-feedback">Campo obligatorio</div>
          </div>
        </div>
        <div class="form-field-item">
          <div class="mb-3 required" [ngClass]="{ err: validateField('numeroDocumento') }">
            <label for="numeroDocumento" class="form-label">NIT</label>
            <input
              type="text"
              minlength="9"
              maxlength="9"
              class="form-control"
              formControlName="numeroDocumento"
              id="numeroDocumento"
              placeholder="Digita NIT"
              (keypress)="validateNumber($event)"
              appNextFieldId="idFuenteNeocredito"
              [ngClass]="{ 'is-invalid': validateField('numeroDocumento') }"
              required
            />
            <div class="invalid-feedback">Campo obligatorio. Solo números, 9 dígitos.</div>
          </div>
        </div>
        <div class="form-field-item">
          <div class="mb-3" [ngClass]="{ 'is-invalid': validateField('idFuenteNeocredito') }" required>
            <label for="idFuenteNeocredito" class="form-label">¿Cómo te enteraste de neocrédito?</label>
            <select
              #idFuenteNeocredito
              id="idFuenteNeocredito"
              class="form-control selectpicker"
              [ngClass]="{ 'is-invalid': validateField('idFuenteNeocredito') }"
              data-live-search="true"
              formControlName="idFuenteNeocredito"
              required
              data-size="6"
              appNextFieldId="anioVentas"
              (change)="valueSelected(juridicoForm.get('idFuenteNeocredito').value)"
              title="Selecciona una opción"
            >
              <option [value]="''" class="option-placeholder">Selecciona una opción</option>
              @for (elemento of fuentesInformacion; track elemento) {
                <option [value]="elemento.idFuenteNeocredito">
                  {{ elemento.fuente }}
                </option>
              }
            </select>
            <div class="invalid-feedback">Campo obligatorio</div>
          </div>
        </div>
      </div>

      <!-- Sección 2: Información financiera -->
      <div class="form-section-header mb-2 mt-4">
        <p class="form-section-header__subtitle mt-3">
          <img src="assets/img/Inicio_sesion/svg/Ico_Info_Financiera.svg"
            alt="" class="form-section-header__icon" aria-hidden="true" />
          Información financiera
        </p>
      </div>
      <div class="form-fields-flow mt-3">
        <div class="form-field-item">
          <div class="mb-3 required" [ngClass]="{ 'is-invalid': validateField('anioVentas') }">
            <label for="anioVentas" class="form-label">Año de ventas</label>
            <select
              class="form-control"
              formControlName="anioVentas"
              id="anioVentas"
              appNextFieldId="valorVentas"
              [ngClass]="{ 'is-invalid': validateField('anioVentas'), 'placeholder-selected': !juridicoForm.get('anioVentas').value }"
              required
            >
              <option [value]="''" class="option-placeholder">Selecciona año de ventas</option>
              @for (anio of anios; track anio) {
                <option [value]="anio">{{ anio }}</option>
              }
            </select>
            <div class="invalid-feedback">Campo obligatorio</div>
          </div>
        </div>
        <div class="form-field-item">
          <div class="mb-3 required" [ngClass]="{ 'is-invalid': validateField('valorVentas') }" required>
            <label for="valorVentas" class="form-label">Ventas del último año</label>
            <input
              type="text"
              maxlength="17"
              class="form-control"
              formControlName="valorVentas"
              id="valorVentas"
              placeholder="Digita ventas del último año"
              (keypress)="validateNumber($event)"
              appNextFieldId="idDepartamento"
              [ngClass]="{ 'is-invalid': validateField('valorVentas') }"
              required
              (keyup)="validarVentaAnual()"
            />
            <div class="invalid-feedback">{{ msjErrorValorVentas }}</div>
          </div>
        </div>
        <div class="form-field-item">
          <div class="mb-3 required" [ngClass]="{ 'is-invalid': validateField('idDepartamento') }" required>
            <label for="idDepartamento" class="form-label">Departamento donde está tu negocio</label>
            <select
              class="form-control selectpicker"
              data-live-search="true"
              data-width="100%"
              data-size="5"
              #idDepartamento
              id="idDepartamento"
              title="Selecciona departamento"
              formControlName="idDepartamento"
              (change)="getCambio($event)"
              [ngClass]="{ 'is-invalid': validateField('idDepartamento') }"
              appNextFieldId="idCiudad"
              required
            >
              <option [value]="''" class="option-placeholder">Selecciona departamento</option>
              @for (departamento of departamentos; track departamento) {
                <option [value]="departamento.idDepartamento">
                  {{ departamento.nombreDepartamento }}
                </option>
              }
            </select>
            <div class="invalid-feedback">Campo es obligatorio</div>
          </div>
        </div>
        <div class="form-field-item">
          <div class="mb-3 required" [ngClass]="{ 'is-invalid': validateField('idCiudad') }" required>
            <label for="idCiudad" class="form-label">Ciudad donde está tu negocio</label>
            <select
              #idCiudad
              id="idCiudad"
              class="form-control selectpicker"
              data-live-search="true"
              data-width="100%"
              data-size="5"
              formControlName="idCiudad"
              title="Selecciona ciudad"
              (change)="onCiudadChange()"
              [ngClass]="{ 'is-invalid': validateField('idCiudad') }"
              [appNextFieldId]="juridicoForm.get('idCiudad').value == idBogota ? 'idLocalidad' : 'codigoCiiu'"
              required
            >
              <option [value]="''" class="option-placeholder">Selecciona ciudad</option>
              @for (ciudad of ciudades; track ciudad) {
                <option [value]="ciudad.idCiudad">
                  {{ ciudad.nombreCiudad }}
                </option>
              }
            </select>
            <div class="invalid-feedback">Campo es obligatorio</div>
          </div>
        </div>
        @if (juridicoForm.get('idCiudad').value == idBogota) {
          <div class="form-field-item">
            <div class="mb-3 required" [ngClass]="{ 'is-invalid': validateField('idLocalidad') }">
              <label for="idLocalidad" class="form-label">Localidad donde está ubicado tu negocio</label>
              <select
                #idLocalidad
                id="idLocalidad"
                class="form-control selectpicker"
                data-live-search="true"
                data-width="100%"
                data-size="5"
                formControlName="idLocalidad"
                title="Selecciona localidad"
                (change)="selectpikerChange('idLocalidad')"
                [ngClass]="{ 'is-invalid': validateField('idLocalidad') }"
                appNextFieldId="codigoCiiu"
              >
                <option [value]="''" class="option-placeholder">Selecciona localidad</option>
                @for (loc of localidades; track loc) {
                  <option [value]="loc.id">
                    {{ loc.nombre }}
                  </option>
                }
              </select>
              <div class="invalid-feedback">Campo es obligatorio</div>
            </div>
          </div>
        }
        <div class="form-field-item">
          <div class="mb-3 required" [ngClass]="{ 'is-invalid': validateField('codigoCiiu') }">
            <label for="codigoCiiu" class="form-label">Actividad económica</label>
            <select
              id="codigoCiiu"
              class="form-control selectpicker"
              [ngClass]="{ 'is-invalid': validateField('codigoCiiu') }"
              data-live-search="true"
              formControlName="codigoCiiu"
              required
              data-size="6"
              appNextFieldId="tiposContacto"
              (change)="selectpikerChange('codigoCiiu')"
              title="Selecciona actividad económica"
            >
              <option [value]="''" class="option-placeholder">Selecciona actividad económica</option>
              @for (ciiu of ciius; track ciiu) {
                <option [value]="ciiu.codigoCiiu" [attr.data-tokens]="ciiu.codigoCiiu">
                  {{ ciiu.codigoCiiu }} - {{ ciiu.nombreCiiu }}
                </option>
              }
            </select>
            <div class="invalid-feedback">Campo obligatorio</div>
          </div>
        </div>
        <div class="form-field-item">
          <div class="mb-3 required" [ngClass]="{ 'is-invalid': validateField('tiposContacto') }">
            <label for="tiposContacto" class="form-label">¿Cómo desea ser contactado?</label>
            <select
              id="tiposContacto"
              class="form-control selectpicker"
              [ngClass]="{ 'is-invalid': validateField('tiposContacto') }"
              data-live-search="true"
              formControlName="tiposContacto"
              required
              data-size="4"
              multiple
              [appNextFieldId]="isReferido ? 'nombreReferido' : (isOtraFuente ? 'otraFuente' : 'primerNombre')"
              data-actions-box="true"
              data-select-all-text="<i class='fas fa-plus'></i> Seleccionar todos"
              data-deselect-all-text="<i class='fas fa-minus'></i> Eliminar todos"
              (change)="selectpikerChangeContactos('tiposContacto')"
              title="Selecciona una opción"
            >
              @for (tipo of listaTiposCont; track tipo) {
                <option [value]="tipo.idTipoContacto">
                  {{ tipo.nombre }}
                </option>
              }
            </select>
            <div class="invalid-feedback">Campo obligatorio</div>
          </div>
        </div>
        @if (isReferido) {
          <div class="form-field-item">
            <div class="mb-3" [ngClass]="{ 'is-invalid': juridicoForm.get('nombreReferido')?.errors?.['referidoRequired'] }">
              <label for="nombreReferido" class="form-label">¿Quién te refirió?</label>
              <input
                type="text"
                class="form-control"
                maxlength="60"
                formControlName="nombreReferido"
                id="nombreReferido"
              placeholder="Digita nombre"
              appNextFieldId="codigoReferido"
              [ngClass]="{ 'is-invalid': juridicoForm.get('nombreReferido')?.errors?.['referidoRequired'] }"
            />
          </div>
        </div>
        <div class="form-field-item">
          <div class="mb-3">
            <label for="codigoReferido" class="form-label">Código del referido</label>
            <input
              type="text"
              class="form-control"
              id="codigoReferido"
              maxlength="20"
              autocomplete="off"
              formControlName="codigoReferido"
              placeholder="Digita código"
              [appNextFieldId]="isOtraFuente ? 'otraFuente' : 'primerNombre'"
            />
          </div>
        </div>
          @if (juridicoForm.get('idFuenteNeocredito').value == '7') {
            <div class="form-field-item" style="grid-column: 1 / -1;">
              <div class="invalid-feedback d-block" *ngIf="juridicoForm.get('nombreReferido')?.errors?.['referidoRequired']">
                Completa al menos uno: ¿Quién te refirió? o Código del referido.
              </div>
            </div>
          }
        }
        @if (isOtraFuente) {
          <div class="form-field-item">
            <div class="mb-3 required" [ngClass]="{ 'is-invalid': validateField('otraFuente') }">
              <label for="otraFuente" class="form-label">¿Cuál?</label>
            <input
              type="text"
              class="form-control"
              id="otraFuente"
              autocomplete="off"
              maxlength="250"
              formControlName="otraFuente"
              placeholder="Especifica cómo te enteraste"
              appNextFieldId="primerNombre"
              [ngClass]="{ 'is-invalid': validateField('otraFuente') }"
            />
            <div class="invalid-feedback">Campo obligatorio</div>
          </div>
        </div>
        }
      </div>

      <div class="row justify-content-center align-items-center mt-3 registro-nav-buttons">
        <div class="col-auto d-flex flex-wrap justify-content-center gap-3">
          <button type="button" class="btn-registro-nav btn-registro-nav--prev" (click)="goToPreviousStep()">
            <span class="btn-registro-nav__icon" aria-hidden="true">&lt;</span>
            <span class="btn-registro-nav__text">Anterior</span>
          </button>
          <button
            type="button"
            class="btn-registro-nav btn-registro-nav--next"
            [disabled]="!isStep1Valid()"
            (click)="goToNextStep()"
          >
            <span class="btn-registro-nav__text">Siguiente</span>
            <span class="btn-registro-nav__icon" aria-hidden="true">&gt;</span>
          </button>
        </div>
      </div>
    }

    @if (currentStep === 2) {
      <div class="form-section-header mb-3">
        <h3 class="form-section-header__title">Información de contacto</h3>
        <p class="form-section-header__subtitle mt-3">
          <img src="assets/img/Inicio_sesion/svg/Ico_Datos_Generales.svg"
            alt="" class="form-section-header__icon" aria-hidden="true" />
          Datos de contacto
        </p>
      </div>
      <div class="form-fields-flow mt-4">
        <div class="form-field-item">
          <div class="mb-3 required" [ngClass]="{ err: validateField('primerNombre') }">
            <label for="primerNombre" class="form-label">Primer nombre</label>
            <input
              class="form-control toCapitalizeWords"
              maxlength="20"
              formControlName="primerNombre"
              placeholder="Digita primer nombre"
              appOnlyLetters
              (keyup)="validarTexto($event)"
              id="primerNombre"
              appNextFieldId="primerApellido"
              [ngClass]="{ 'is-invalid': validateField('primerNombre') }"
              required
            />
            <div class="invalid-feedback">Campo obligatorio</div>
          </div>
        </div>
        <div class="form-field-item">
          <div class="mb-3 required" [ngClass]="{ err: validateField('primerApellido') }">
            <label for="primerApellido" class="form-label">Primer apellido</label>
            <input
              class="form-control toCapitalizeWords"
              maxlength="20"
              formControlName="primerApellido"
              id="primerApellido"
              placeholder="Digita primer apellido"
              appOnlyLetters
              (keyup)="validarTexto($event)"
              appNextFieldId="idTipoDocIdentidad"
              [ngClass]="{ 'is-invalid': validateField('primerApellido') }"
              required
            />
            <div class="invalid-feedback">Campo obligatorio</div>
          </div>
        </div>
        <div class="form-field-item">
          <div class="mb-3 required" [ngClass]="{ 'is-invalid': validateField('idTipoDocIdentidad') }">
            <label for="idTipoDocIdentidad" class="form-label">Tipo de documento</label>
            <select
              class="form-control"
              formControlName="idTipoDocIdentidad"
              id="idTipoDocIdentidad"
              [ngClass]="{ 'is-invalid': validateField('idTipoDocIdentidad'), 'placeholder-selected': !juridicoForm.get('idTipoDocIdentidad').value }"
              (change)="validarSelect()"
              [appNextFieldId]="juridicoForm.get('idTipoDocIdentidad').value !== '2' ? 'idPaisOrigen' : 'numeroDocumentoP'"
              required
            >
              <option [value]="''" class="option-placeholder">Selecciona tipo documento</option>
              @for (documento of documentos; track documento) {
                <option [value]="documento.idTipoDocIdentidad">
                  {{ documento.nombre }}
                </option>
              }
            </select>
            <div class="invalid-feedback">Campo obligatorio</div>
          </div>
        </div>
        @if (isPasaporte) {
          <div class="form-field-item">
            <div class="mb-3 required" [ngClass]="{ 'is-invalid': validateField('idPaisOrigen') }" required>
              <label for="idPaisOrigen" class="form-label">¿Cuál es tu nacionalidad?</label>
              <select
                class="form-control selectpicker"
                data-live-search="true"
                data-width="100%"
                data-size="5"
                #idPaisOrigen
                id="idPaisOrigen"
                title="Selecciona país"
                formControlName="idPaisOrigen"
                appNextFieldId="numeroDocumentoP"
                (change)="selectpikerChange('idPaisOrigen')"
                [ngClass]="{ 'is-invalid': validateField('idPaisOrigen') }"
                required
              >
                <option [value]="''" class="option-placeholder">Selecciona país</option>
                @for (pais of paises; track pais) {
                  <option [value]="pais.idPais">
                    {{ pais.nombrePais }}
                  </option>
                }
              </select>
              <div class="invalid-feedback">Campo es obligatorio</div>
            </div>
          </div>
        }
        <div class="form-field-item">
          <div class="mb-3 required" [ngClass]="{ 'is-invalid': validateField('numeroDocumentoP') }">
            <label for="numeroDocumentoP" class="form-label">Número de documento</label>
            <input
              type="text"
              class="form-control"
              formControlName="numeroDocumentoP"
              id="numeroDocumentoP"
              placeholder="Digita documento"
              maxlength="15"
              appNumeroDocumentoPorTipo
              [idTipoDocControlName]="'idTipoDocIdentidad'"
              [tipos]="documentos"
              appNextFieldId="confirmNumeroDocumento"
              [ngClass]="{ 'is-invalid': validateField('numeroDocumentoP') }"
              aria-describedby="numeroDocumentoP-error"
              required
            />
            <div class="invalid-feedback d-block" id="numeroDocumentoP-error" *ngIf="validateField('numeroDocumentoP')">
              {{ juridicoForm.get('numeroDocumentoP').hasError('required') ? 'Campo obligatorio' : getDocumentPatternMessage('numeroDocumentoP') }}
            </div>
          </div>
        </div>
        <div class="form-field-item">
          <div class="mb-3 required" [ngClass]="{ 'is-invalid': validateField('confirmNumeroDocumento') || juridicoForm.controls.confirmNumeroDocumento?.hasError('confirmNumeroDocumentoMatch') }">
            <label for="confirmNumeroDocumento" class="form-label">Confirma tu número de documento</label>
            <input
              type="text"
              class="form-control"
              formControlName="confirmNumeroDocumento"
              id="confirmNumeroDocumento"
              placeholder="Digita nuevamente documento"
              maxlength="15"
              appNumeroDocumentoPorTipo
              [idTipoDocControlName]="'idTipoDocIdentidad'"
              appNextFieldId="idGenero"
              [tipos]="documentos"
              [allowPaste]="false"
              oncopy="return false"
              [ngClass]="{ 'is-invalid': validateField('confirmNumeroDocumento') || juridicoForm.controls.confirmNumeroDocumento?.hasError('confirmNumeroDocumentoMatch') }"
              aria-describedby="confirmNumeroDocumento-error mensaje-error-confirmNumeroDocumento"
              required
            />
            <div class="invalid-feedback d-block" id="confirmNumeroDocumento-error" *ngIf="juridicoForm.controls.confirmNumeroDocumento?.hasError('confirmNumeroDocumentoMatch')">
              Los números de documento no coinciden
            </div>
            <div class="invalid-feedback d-block" id="mensaje-error-confirmNumeroDocumento" *ngIf="validateField('confirmNumeroDocumento') && !juridicoForm.controls.confirmNumeroDocumento?.hasError('confirmNumeroDocumentoMatch')">
              {{ juridicoForm.get('confirmNumeroDocumento').hasError('required') ? 'Campo obligatorio' : getDocumentPatternMessage('confirmNumeroDocumento') }}
            </div>
          </div>
        </div>
        <div class="form-field-item">
          <div class="mb-3 required" [ngClass]="{ 'is-invalid': validateField('idGenero'), 'placeholder-selected': !juridicoForm.get('idGenero').value }">
            <label for="idGenero" class="form-label">Género</label>
            <select
              id="idGenero"
              class="form-control"
              formControlName="idGenero"
              appNextFieldId="numeroCelular"
              [ngClass]="{ 'is-invalid': validateField('idGenero'), 'placeholder-selected': !juridicoForm.get('idGenero').value }"
              required
            >
              <option [value]="''" class="option-placeholder">Selecciona género</option>
              @for (genero of generos; track genero) {
                <option [value]="genero.idGenero">
                  {{ genero.nombre }}
                </option>
              }
            </select>
            <div class="invalid-feedback">Campo obligatorio</div>
          </div>
        </div>
        <div class="form-field-item">
          <div class="mb-3 required" [ngClass]="{ 'is-invalid': validateField('numeroCelular') }">
            <label for="numeroCelular" class="form-label">Número de celular</label>
            <input
              class="form-control"
              minlength="10"
              maxlength="10"
              formControlName="numeroCelular"
              placeholder="Digita número de celular"
              (keypress)="validateNumber($event)"
              appNextFieldId="correoElectronico"
              id="numeroCelular"
              [ngClass]="{ 'is-invalid': validateField('numeroCelular') }"
              required
            />
            <div class="invalid-feedback">Campo obligatorio. Máximo 10 dígitos.</div>
          </div>
        </div>
        <div class="form-field-item">
          <div class="mb-3 required" [ngClass]="{ err: validateField('correoElectronico') }">
            <label for="correoElectronico" class="form-label">Correo electrónico</label>
            <input
              type="email"
              class="form-control"
              maxlength="50"
              formControlName="correoElectronico"
              placeholder="Digita correo electrónico"
              (input)="juridicoForm.get('correoElectronico').setValue($event.target.value.toLowerCase())"
              appNextFieldId="tratamientoDatos"
              [ngClass]="{ 'is-invalid': validateField('correoElectronico') }"
              id="correoElectronico"
              required
            />
            <div class="invalid-feedback d-block" *ngIf="validateField('correoElectronico')">
              {{ getCorreoElectronicoErrorMessage() }}
            </div>
          </div>
        </div>        
      </div>

      <div class="politicas mt-3">
        <div>
          <div class="form-check">
            <input
              type="checkbox"
              class="form-check-input"
              id="tratamientoDatos"
              [ngClass]="{ 'is-invalid': validateField('tratamientoDatos') }"
              formControlName="tratamientoDatos"
            />
            <label for="tratamientoDatos" class="form-check-label">
              Al seleccionar, aceptas nuestra
              <span
                (click)="showModal('P')"
                (keydown.enter)="showModal('P')"
                data-bs-target="#politicasModal"
                data-bs-toggle="modal"
                >política de tratamiento de datos personales.</span
              >
            </label>
          </div>
          <div class="form-check">
            <input
              type="checkbox"
              class="form-check-input"
              [ngClass]="{ 'is-invalid': validateField('terminosCondiciones') }"
              formControlName="terminosCondiciones"
            />
            <label for="terminosCondiciones" class="form-check-label">
              Al seleccionar, aceptas nuestros
              <span
                (click)="showModal('T')"
                (keydown.enter)="showModal('T')"
                data-bs-target="#politicasModal"
                data-bs-toggle="modal"
                >términos y condiciones.</span
              >
            </label>
          </div>
        </div>
      </div>

      <div class="row justify-content-center align-items-center mt-3 mb-3 registro-nav-buttons">
        <div class="col-auto d-flex flex-wrap justify-content-center gap-3">
          <button type="button" class="btn-registro-nav btn-registro-nav--prev" (click)="goToPreviousStep()">
            <span class="btn-registro-nav__icon" aria-hidden="true">&lt;</span>
            <span class="btn-registro-nav__text">Anterior</span>
          </button>
          <button type="button" class="btn-registro-nav btn-registro-nav--next" disabled>
            <span class="btn-registro-nav__text">Siguiente</span>
            <span class="btn-registro-nav__icon" aria-hidden="true">&gt;</span>
          </button>
        </div>
      </div>
      <div class="row justify-content-center mt-4 mb-3">
        <div class="col-auto">
          <button class="btn-registro-nav btn-registro-nav--finish" type="submit" [disabled]="!isStep2Ready()">
            <span class="btn-registro-nav__text">Finalizar registro</span>
            <img src="assets/img/Inicio_sesion/svg/Ico_Finalizar_registro.svg" alt="" class="btn-registro-nav__icon-img" aria-hidden="true" />
          </button>
        </div>
      </div>
    }
  </div>
</form>
<politicas-modal [title]="titleModal"></politicas-modal>
